export const findLabelByKey = key => label => label?.labelKey === key;
//# sourceMappingURL=findLabelByKey.js.map